import TagManager, { TagManagerArgs } from 'react-gtm-module';

export function tagManagerInit(tagManagerConfig: TagManagerArgs): void {
    TagManager.initialize(tagManagerConfig);
}
